<template>
  <div ref="chartWrapper"></div>
</template>

<script>
export default {
  mounted() {
    // force re draw chart on tab change
    $(document).on("shown.bs.tab", e => {
      this.chart.flush();
    });

    // create the chart
    this.$nextTick(() => {
      this.chart = c3.generate({
        bindto: this.$refs.chartWrapper,
        data: {
          json: this.data,
          keys: {
            x: "date",
            value: ["value"]
          },
          type: "area-spline",
          color: () => {
            return this.colors[this.color];
          }
        },

        // options --------
        size: {
          height: 150,
          width: undefined
        },
        padding: {
          top: 0,
          right: 0,
          bottom: 0,
          left: 0
        },
        interaction: {
          enabled: false
        },
        point: {
          show: false
        },
        subchart: {
          show: false
        },
        grid: {
          x: {
            show: false
          },
          y: {
            show: true,
            lines: true
          }
        },
        axis: {
          y: {
            show: false
          },
          x: {
            show: false,
            type: "category",
            tick: {
              rotate: -30,
              multiline: false,
              culling: true,
              format: "%Y-%m-%d"
              // format: function (x) {
              //   let date = new Date(x);
              //   return `${date.getMonth() - 1}/${date.getFullYear()}`;
              // },
            }
          }
        },
        legend: {
          hide: true
        }
      });
    });
  },
  props: ["data", "color", "showAxis"],
  data() {
    return {
      chart: null,
      colors: {
        'text-green': "#008561",
        'text-danger': "#FF5758"
      }
    };
  }
};
</script>
